import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=1aa0778f&scoped=true&"
import script from "./MediaImage.vue?vue&type=script&lang=js&"
export * from "./MediaImage.vue?vue&type=script&lang=js&"
import style0 from "./MediaImage.vue?vue&type=style&index=0&id=1aa0778f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0778f",
  null
  
)

export default component.exports